export default __webpack_public_path__ + "static/media/angle-up.b63df81e.svg";